// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "whatsapp_template".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { whatsappTemplateStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "whatsapp_template" table (1:1 with a DB row, on the wire). */
export const whatsappTemplateAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    name: z.string(),
    languageCode: z.string(),
    category: z.string().nullable(),
    status: z.enum(whatsappTemplateStatusValues),
    body: z.string(),
    metaTemplateId: z.string().nullable(),
    rejectionReason: z.string().nullable(),
    syncedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=whatsappTemplate.js.map